import {inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {Organization} from '@interfaces/organization';
import {HttpClient} from '@angular/common/http';
import {EnvironmentService} from '@services/enviroment/environment.service';
import {map} from 'rxjs/operators';
import {AccountTypeEnum} from '@interfaces/doctors';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  organizations$: BehaviorSubject<Organization[]> = new BehaviorSubject<Organization[]>([]);


  protected readonly http = inject(HttpClient);
  private environmentService = inject(EnvironmentService);

  apiUrl = this.environmentService.getValue('apiUrl');

  fetchOrganizations(): Observable<Organization[]> {
    return this.http.get(this.apiUrl + '/organizations').pipe(
      map((res: any) => res.organizations),
    )
  }

  fetchOrganization(id: string) {
    return this.http.get(this.apiUrl + '/organizations/' + id).pipe(
      map((res: any) => res.organizations),
    )
  }

  createNewOrganization(organization: any) {
    return this.http.post(this.apiUrl + '/organizations', organization)
  }

  inviteUser(organizationId: string, email: string, role: AccountTypeEnum) {
    return this.http.post(this.apiUrl + '/invitations', {
        organization_id: organizationId,
        email: email,
        role: role
      }
    )
  }

  getOrganizationInvitedUsers(organizationId: string) {
    return this.http.get(this.apiUrl + '/organizations/' + organizationId + '/invited_users').pipe(
      map((res: any) => res.users),
    )
  }

  getOrganizationRegisteredUsers(organizationId: string) {
    return this.http.get(this.apiUrl + '/organizations/' + organizationId + '/registered_users').pipe(
      map((res: any) => res.users),
    )
  }

  getReferralSettings(organizationId: string) {
    return this.http.get<any>(`${this.apiUrl}/v1/admin/organizations/${organizationId}/referrals`);
  }
  updateReferralSettings(organizationId: string, value: any) {
    return this.http.patch<any>(`${this.apiUrl}/v1/admin/organizations/${organizationId}/referrals`, value);
  }
  createOrRotateReferralLink(organizationId: string) {
    return this.http.post<any>(`${this.apiUrl}/v1/admin/organizations/${organizationId}/referrals`, {});
  }
  revokeReferralLink(organizationId: string) {
    return this.http.delete(`${this.apiUrl}/v1/admin/organizations/${organizationId}/referrals`);
  }
}
